<div class='AcceptPolicy container'>
  <h4>Acceptable Use Policy</h4>
  <br />
  <p style='text-align:justify;'>Retreva&reg; users must follow our Acceptable Use Policy. If this policy is violated,
    we reserve the right to terminate or suspend your account.</p>
  <br />
  <h5>Prohibited Content</h5>
  <br />
  Retreva&reg; may not be used to promote anything illegal, or to offend or harass anyone. We do not allow:
  <ul style='margin-left:20px;float:none'>
    <li class='bullets_listing'>Emails offering illegal goods or services</li>
    <li class='bullets_listing'>Sexually explicit or Pornography Emails</li>
    <li class='bullets_listing'>Emails that violate CAN-SPAM Laws</li>
  </ul>
  <br />
  <h5>Prohibited Actions</h5>
  <br />
  The following actions are prohibited by Retreva&reg;:
  <ul style='margin-left:20px;float:none'>
    <li style='list-style: disc'>Email any material that wasn’t created by you or that would violate anyone's rights.
      This includes text, photos, graphics, and other content.
    </li>
    <li style='list-style: disc'>Use any misleading or incorrect names, addresses, email addresses, subject lines, or
      other information on the Website or in any Emails created or sent using our Service
    </li>
    <li style='list-style: disc'>Import or incorporate any of this information into any lists, emails or uploads to our
      servers: Social Security numbers, passwords, security credentials, or sensitive personal information of any kind.
    </li>
    <li style='list-style: disc'>Reverse engineer any of the materials or features on our Website.</li>
    <li style='list-style: disc'>Use any of the materials, features or logic on our Website to create a competing
      product.
    </li>
  </ul>

  <h3>Terms of Use</h3>
  <br />
  <br />
  <h5>Terms</h5>
  <br />
  <p style='text-align:justify;'>By accessing this website and signing up for an account, you are agreeing to be bound
    by these website Terms and Conditions of Use, all applicable laws and regulations, and agree that you are
    responsible for compliance with any applicable local laws. If you do not agree with any of these terms, you are
    prohibited from using or accessing this website. This site and its original content, features and functionality are
    owned by Retreva&reg; and are protected by international copyright, trademark, patent, trade secret and other
    intellectual property or proprietary rights laws.</p>
  <br />
  <h5>Use License</h5>
  <br />
  <p style='text-align:justify;'>Permission is granted to use the materials (information or software) and features on
    Retreva&reg; LLC's website. You may not: modify or copy the materials or features; use the materials or features for
    any commercial purpose, or for any public display (commercial or non-commercial); attempt to decompile or reverse
    engineer any software contained on Retreva&reg; LLC's website; remove any copyright or other proprietary notations
    from the materials; or transfer the materials to another person or "mirror" the materials on any other server. Your
    service will automatically terminate if you violate any of these restrictions at any time. Upon terminating your
    viewing of these materials or upon the termination of this license, you must destroy any downloaded materials in
    your possession whether in electronic or printed format.</p>
  <br />
  <h5>Termination</h5>
  <br />
  <p style='text-align:justify;'>You or Retreva&reg; may terminate the service at any time and for any reason by giving
    notice to the other party by submitting an email to help@retreva.com or by Retreva&reg; sending an email to your
    email address associated with your account. We may suspend our Service to you at any time, with or without cause. If
    we terminate your account without cause, we'll refund a prorated portion of your monthly prepayment service fee.
    There will be no refund or reimbursement for termination with cause, like a violation of these Terms or our
    Acceptable Use Policy. Once terminated, we may permanently delete your account and all the data associated with
    it.</p>
  <br />
  <h5>Disclaimer</h5>
  <br />
  <p style='text-align:justify;'>The materials and features on Retreva&reg; LLC's website are provided "as is". Retreva&reg; LLC
    makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties, including without
    limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or
    non-infringement of intellectual property or other violation of rights. Further, Retreva&reg; LLC does not warrant
    or make any representations concerning the accuracy, likely results, or reliability of the use of the materials and
    features on its Internet website or otherwise relating to such materials and features or on any sites linked to this
    site.</p>
  <br />
  <h5>Limitations</h5>
  <br />
  <p style='text-align:justify;'>In no event shall Retreva&reg; LLC or its suppliers be liable for any damages
    (including, without limitation, damages for loss of data or profit, CAN-SPAM Compliance claims, contact inaccuracies
    or business interruption,) arising out of the use or inability to use the materials and features on Retreva&reg; LLC's
    Internet site, even if Retreva&reg; LLC or a Retreva&reg;LLC authorized representative has been notified orally or
    in writing of the possibility of such damage. Because some jurisdictions do not allow limitations on implied
    warranties, or limitations of liability for consequential or incidental damages, these limitations may not apply to
    you.</p>
  <br />
  <h5>Revisions and Errata</h5>
  <br />
  <p style='text-align:justify;'>The materials and features appearing on Retreva&reg; LLC's website could include
    technical, typographical, or photographic errors. Retreva&reg; LLC does not warrant that any of the materials and
    features on its website are accurate, complete, or current. Retreva&reg; LLC may make changes to the materials and
    features contained on its website at any time without notice. Retreva&reg; LLC does not, however, make any
    commitment to update the materials and features.</p>
  <br />
  <h5>Links</h5>
  <br />
  <p style='text-align:justify;'>Retreva&reg; LLC has not reviewed all of the sites linked to its Internet website and
    is not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement by
    Retreva&reg; LLC of the site. Use of any such linked website is at the user's own risk.</p>
  <br />
  <h5>Site Terms of Use Modifications</h5>
  <br />
  <p style='text-align:justify;'>Retreva&reg; LLC may revise these terms of use for its website at any time without
    notice. By using this website you are agreeing to be bound by the then current version of these Terms and Conditions
    of Use.</p>
  <h5>Governing Law</h5>
  <br />
  <p style='text-align:justify;'>Any claim relating to Retreva&reg; LLC's website shall be governed by the laws of the
    State of Ohio without regard to its conflict of law provisions.</p>
  <br />
  <h5>Privacy Policy</h5>
  <br />

  <p style='text-align:justify;'>
    This privacy notice discloses the privacy practices for http://click2sell.com. This privacy notice applies solely to
    information collected by this website. It will notify you of the following:<br>
    What personally identifiable information is collected from you through the website, how it is used and with whom it
    may be shared. What choices are available to you regarding the use of your data. The security procedures in place to
    protect the misuse of your information. How you can correct any inaccuracies in the information.
  </p>

  <br />
  <h4>Information Collection, Use, and Sharing</h4>
  <br />

  <p style='text-align:justify;'>
    We are the sole owners of the information collected on this site. We only have access to/collect information that
    you voluntarily give us via email or other direct access from you. We will not sell or rent any information entered
    into our service to anyone.<br>
    We will use your information to respond to you, regarding the reason you contacted us. We will not share your
    information with any third party outside of our organization, other than as necessary to fulfill your request.<br>
    Unless you ask us not to, we may contact you via email in the future to tell you about specials, new products or
    services, or changes to this privacy policy.
  </p>

  <br />
  <h4>Your Access to and Control Over Information</h4>
  <br />

  <p style='text-align:justify;'>
    You may opt out of any future contacts from us at any time. You can do the following at any time by contacting us
    via the email address or phone number given on our website:<br>
    See what data we have about you, if any.<br>
    Change/correct any data we have about you.<br>
    Have us delete any data we have about you.<br>
    Express any concern you have about our use of your data.
  </p>

  <br />
  <h4>Security</h4>
  <br />

  <p style='text-align:justify;'>
    We take precautions to protect your information. When you submit sensitive information via the website, your
    information is protected both online and offline.<br>
    Wherever we collect sensitive information (such as credit card data), that information is encrypted and transmitted
    to us in a secure way. You can verify this by looking for a closed lock icon at the bottom of your web browser, or
    looking for "https" at the beginning of the address of the web page.<br>
    While we use encryption to protect sensitive information transmitted online, we also protect your information
    offline. Only employees who need the information to perform a specific job (for example, billing or customer
    service) are granted access to personally identifiable information. The computers/servers in which we store
    personally identifiable information are kept in a secure environment.
  </p>

</div>
